import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../resources/logo.webp'

const MailComponent = () => {
    return (
        <form className='text-white form-login mx-auto m-auto rounded-xl py-10 px-8 flex flex-col shadow-md login'>
            <div className='logo mb-6 flex items-center justify-center'>
                <img src={Logo} />
                <h1 className='uppercase text-4xl tracking-tight ml-5'>Validation <br />Software</h1>
            </div>
            <div className='mb-5'>
                <p>Confirme si es su identidad para pasar a la siguient etapa del curso</p>
            </div>
            <div className="grid grid-cols-2 gap-6">
                <div className="relative z-0 mb-6 mt-2 w-full group">
                    <p className='border-b-2 pt-2 pb-1 text-gray-500'>Yenky</p>
                    <span className='color-p text-xs absolute -top-2'>Nombre/s</span>
                </div>
                <div className="relative z-0 mb-6 mt-2 w-full group">
                    <p className='border-b-2 pt-2 pb-1 text-gray-500'>Valera Villareal </p>
                    <span className='color-p text-xs absolute -top-2'>Apellido/s</span>
                </div>
            </div>
            <div className="grid grid-cols-2 gap-6">
                <div className="relative z-0 mb-6 mt-2 w-full group">
                    <p className='border-b-2 pt-2 pb-1 text-gray-500'>300724841</p>
                    <span className='color-p text-xs absolute -top-2'>Teléfono</span>
                </div>
                <div className="relative z-0 mb-6 mt-2 w-full group">
                    <p className='border-b-2 pt-2 pb-1 text-gray-500'>micorreo@gmal.com</p>
                    <span className='color-p text-xs absolute -top-2'>Mail</span>
                </div>
            </div>
            <div className="grid grid-cols-2 gap-6">
                <div className="relative z-0 mb-6 mt-2 w-full group">
                    <p className='border-b-2 pt-2 pb-1 text-gray-500'>72023358</p>
                    <span className='color-p text-xs absolute -top-2'>Documento</span>
                </div>
                <div className="relative z-0 mb-6 mt-2 w-full group">
                    <p className='border-b-2 pt-2 pb-1 text-gray-500'>CRA 16A N 29A74</p>
                    <span className='color-p text-xs absolute -top-2'>Dirección</span>
                </div>
            </div>
            <div className="relative mb-6 z-0 mt-2 w-full group">
                <p className='border-b-2 pt-2 pb-1 text-gray-500'>08001000000015510939</p>
                <span className='color-p text-xs absolute -top-2'>Comparendo</span>
            </div>

            <div className="relative z-0 w-full flex flex-col acepted">
                <div>
                    <input id='terminos' className='mr-1 mb-0 cursor-pointer' type={'checkbox'} />
                    <label htmlFor='terminos' className='text-sm cursor-pointer'>Acepto los <b className='underline color-p opacity-90 hover:opacity-100'>terminos y condiciones</b></label>
                </div>
                <div>
                    <input id='datos' className='mr-1 mb-0 cursor-pointer' type={'checkbox'} />
                    <label htmlFor='datos' className='text-sm cursor-pointer'>Acepto la ley de tratamientos de datos personales</label>
                </div>

            </div>

            <Link to={'/validation-software/validation'} className='mx-auto'>
                <button type="submit" id='button-submit' className="text-white opacity-90 hover:opacity-100 focus:ring-4 font-medium rounded-lg text-sm px-3 pt-2 pb-1.5 focus:outline-none mt-8 transition-all">Validar Identidad</button>
            </Link>
        </form>
    );
}

export default MailComponent;
